export default "__VITE_ASSET__BgNVzQsD__"